import React from 'react';
import { Link } from 'react-router-dom';
import './SeeOurPark.css';

function SeeOurPark() {
  return (
    <div className="see-our-park">
      <div className="see-our-park-text-container">
        <div className="see-our-park-title">See Our Park</div>
        <div className="see-our-park-description">
          Come explore our beautifully designed dog park, where your pups can have the time of their lives! 
          Our park is equipped with ample space for running, playful activities, and comfortable spots for you to relax.
        <br></br><br />
          Ready to see more? 
        </div>
        <Link to="/Dog-Park">
          <button className="see-our-park-button">More Details on Our Park Here</button>
        </Link>
      </div>
      <div className="see-our-park-image">
        <img src="https://res.cloudinary.com/dboapnol9/image/upload/v1779136052/DSC_0583_xuomdd.jpg" alt="A dog running across the grass at DJ's Dog Bar" />
      </div>
    </div>
  );
}

export default SeeOurPark;
